import { useCallback } from 'react'
import { ProviderType } from '../types'
import useUserRoles from 'features/account/state/useUserRoles'
import { useAccountGovernanceConnections } from 'features/account/hooks/useAccountGovernanceConnections'
import { useAppSelector } from 'app/state'

export function useGovernanceConnections() {
  const { data, isLoading: loading, error, refetch } = useAccountGovernanceConnections()
  const { userIsAdmin } = useUserRoles()
  const hideCartoDatawarehouse = useAppSelector((state) => state.account.data.hideCartoDatawarehouse)

  const allowEditorsToCreate = data?.allowEditorsToCreate || userIsAdmin || false
  const availableProviders = data?.providers
  const cartoDataWarehouse = data?.cartoDataWarehouse && !hideCartoDatawarehouse
  const allowSharing = data?.allowSharing || false
  // Check if there are any available providers
  const hasAvailableProviders =
    Object.keys(availableProviders || {}).length > 0 &&
    Object.values(availableProviders || {}).some((provider) => provider)

  /**
   * Checks if a specific permission is available for a given provider
   * @param provider - The provider type to check permissions for
   * @param permission - The specific permission to check (e.g., 'oauth', 'serviceAccount', 'usernamePassword')
   * @returns true if the permission is available for the provider, false otherwise
   */
  const checkProviderPermissions = useCallback(
    (provider: ProviderType, permission: string) => {
      if (availableProviders?.[provider]?.[permission]) {
        return true
      }
      return false
    },
    [availableProviders]
  )

  return {
    loading,
    error,
    data,
    availableProviders,
    checkProviderPermissions,
    hasAvailableProviders,
    allowEditorsToCreate,
    cartoDataWarehouse,
    allowSharing,
    refetch
  }
}
